export default () => {
  const footer = $("#footer");

  if (footer) {
    const isEN = shoptet.cookie.get("language") === "en";
    $("time").remove();
    $(".copyright").html(
      `${!isEN
        ? "Copyright 2019-2024 The Miners, Všechny práva vyhrazená."
        : "Copyright 2019-2024 The Miners, All rights reserved."
      }`
    );

    $("#signature").html(`<span>${!isEN ? "Vytvořilo" : "Made by"}</span>
      <a href="https://liffstudio.com/" target="_blank" class="liffstudio">
        Liff Studio
      </a>
      <span>
        ${!isEN ? "na platformě" : "on platform"}
      </span>
      <a href="https://www.shoptet.cz/?utm_source=footer&amp;utm_medium=link&amp;utm_campaign=create_by_shoptet" title="Shoptet" class="title" target="_blank">Shoptet</a>
    `);
    const mail = "mailto:ASK@THEMINERS.EU";
    const mailText = "ask@theminers.eu";
    const facebook = $(".contact-box .facebook a").attr("href");
    const instagram = $(".contact-box .instagram a").attr("href");
    const instagramesp = "https://www.instagram.com/theminerscoffee_es";
    const tiktok = "https://www.tiktok.com/@theminerscoffee";
    const tiktokesp = "https://www.tiktok.com/@theminerscoffee_es";
    const languageLinkBase = isEN ? "/en" : "";

    $(".footer-rows").html(`
        <div class="row custom-footer elements-2">
          <div class="custom-footer__section1 col-sm-6">
            <div class="news-item-widget">
                <a href="${languageLinkBase}/${isEN ? "about" : "o-nas"}">
                  ${isEN ? "About" : "O nás"}
                </a>
            </div>
            <div class="news-item-widget">
                <a href="${languageLinkBase}/${isEN ? "e-shop" : "e-shop"}">
                   ${isEN ? "Shop" : "Shop"}
                </a>
            </div>
            <div class="news-item-widget">
                <a href="${languageLinkBase}/${isEN ? "menu" : "menu"}">
                   ${isEN ? "Menu" : "Menu"}
                </a>
            </div>
            <div class="news-item-widget">
                <a href="${languageLinkBase}/${isEN ? "community" : "community"}">
                   ${isEN ? "Community" : "Community"}
                </a>
            </div>
            <div class="news-item-widget">
               <a href="https://b2b.theminers.eu/">
                  ${isEN ? "For Businesses" : "Pro firmy"}
               </a>
            </div>
            <div class="news-item-widget">
               <a href="https://insider.theminers.eu/">
                  ${isEN ? "Franchise" : "Franšíza"}
               </a>
            </div>
            <div class="news-item-widget">
                <a href="${languageLinkBase}/${isEN ? "faq" : "caste-dotazy"}">
                  ${isEN ? "FAQ" : "Často kladené otázky"}
                </a>
            </div>
            <div class="news-item-widget">
                <a href="${languageLinkBase}/${isEN ? "careers" : "careers"}">
                ${isEN ? "Careers" : "Kariéra"}
                </a>
            </div>
            <div class="news-item-widget">
                <a href="${languageLinkBase}/${isEN ? "contacts" : "kontakty"}">
                  ${isEN ? "Contacts" : "Kontakty"}
                </a>
            </div>
            <div class="news-item-widget">
            <a href="https://b2b.theminers.eu/subscription-form">
               ${isEN ? "Sign up for newsletters" : "Přihlaste se k odběru newsletterů"}
            </a>
         </div>
          </div>
          <div class="custom-footer__section2 col-sm-6">
            <div class="news-item-widget">
              <span>${isEN ? "Follow us" : "Sledujte nás"}</span>
            </div>
            <div class="news-item-widget">
              <a class="fb" target="_blank" href="${facebook}">Facebook</a>
            </div>
            <div class="news-item-widget">
              <a class="ig" target="_blank" href="${instagram}">Instagram</a>
              \/
              <a class="ig.esp" target="_blank" href="${instagramesp}">Instagram Español</a>
            </div>
            <div class="news-item-widget">
              <a class="tt" target="_blank" href="${tiktok}">TIKTOK</a>
              \/
              <a class="tt.esp" target="_blank" href="${tiktokesp}">TIKTOK Español</a>
            </div>
            <div class="news-item-widget">
              <span>Email</span>
            </div>
            <div class="news-item-widget mb">
              <a class="mail" href="${mail}">${mailText}</a>
            </div>
            <div class="news-item-widget">
              <a href="${languageLinkBase}/${isEN ? "privacy-policy" : "podminky-ochrany-osobnich-udaju"}">
                ${isEN ? "Privacy policy" : "Ochrana osobních údajů"}
              </a>
            </div>
            <div class="news-item-widget">
              <a href="${languageLinkBase}/cookies">Cookies</a>
            </div>
            <div class="news-item-widget mb">
              <a href="${languageLinkBase}/${isEN ? "terms-and-conditions" : "obchodni-podminky"}">
                ${isEN ? "Terms and Conditions" : "Obchodní podmínky"}
              </a>
            </div>
            <div class="news-item-widget mb">
              <a href="${languageLinkBase}/${isEN ? "information-for-shareholders" : "informace-pro-akcionare"}">
                ${isEN ? "Information for shareholders" : "Informace pro akcionáře"}
              </a>
            </div>
            <div class="news-item-widget">
              <a href="${languageLinkBase}/login">
              ${isEN ? "Log in" : "Přihlásit se"}
              </a>
            </div>
          </div>
        </div>
    `);
  }
};